import React from "react";
import classNames from "classnames";
import { css } from 'emotion'
import { btnStyles } from "../_styles/button";

declare type FooterProps = {
    onButtonClick: () => void,
    buttonText: string,
}
export class Footer extends React.Component<FooterProps> {
    render() {
        return <div>
            {/* DO NOT DELETE following line. We need to add extra 70 pixel for footer */}
            <div style={{ height: 70 }} />
            <div className="footer">
                <div className="container-fluid small-gutter text-right pr-lg-7 pl-lg-7 pr-md-5 pl-md-5">
                    <a className={classNames(['button', css(btnStyles.default)])} onClick={this.props.onButtonClick}>
                        {this.props.buttonText}
                    </a>
                </div>
            </div>
        </div>
    }
}